import React, { useContext } from "react";
import ConfigContext from "../../context/ConfigContext";
import { useApiRequest } from "../useApiRequest";
import { Document1099 } from "./Document1099";
import loader from "../../content/images/icon_loading.gif";

export const View1099 = ({ viewer }) => {
	const configData = useContext(ConfigContext);
	const { data, error, isLoaded } = useApiRequest(configData.REACT_APP_VIEW_1099_URL + "/GetYearList");

	if (error !== null) {
		console.log("error fetching years for 1099s: ", error.message);
		return <div>Error: Unable to retrieve 1099s</div>;
	}
	if (!isLoaded) {
		return <img src={loader} alt="Loading " />;
	}
	if (isLoaded) {
		return (
			<div>
				<div>
					{data && <Document1099 years={data} viewer={viewer}/>}
				</div>
			</div>
		);
	}
};